<template>
	<div>
		<div class="search-bar">
			<v-text-field
					v-model="search"
					append-icon="mdi-magnify"
					label="Search"
					single-line
					hide-details
			></v-text-field>
		</div>
		<TableRefresh 
				:state="loading"
				@click.native="getJobs"
		/>
		<v-data-table
			:search="search"
			:headers="headers"
			:items="jobs"
			:loading="loading"
			:expanded.sync="expanded"
			class="elevation-1 admin-table"
			@click:row="clickRow"
		>
			<template v-slot:item.created_on="{ item }">
				{{ formateCreatedDate(item.created_on) }}
			</template>
			<template v-slot:item.completed_on="{ item }">
				{{ formateCreatedDate(item.completed_on) }}
			</template>
			<template v-slot:expanded-item="{ headers, item }">
				<td :colspan="headers.length" class="mx-auto grey lighten-2" style="max-width: 80vw;">
					<v-data-iterator :items="item.Tasks">
						<template v-slot:default="{items}">
							<v-row>
								<v-col v-for="task in items" :key="task.id" cols="12" sm="6" md="4" lg="3">
									<v-card>
										<v-card-title>
											<h4>{{ task.name }}</h4>
										</v-card-title>
										<v-divider></v-divider>
										<v-list dense>
											<v-list-item>
												<v-list-item-content>Cretaed Vehicles:</v-list-item-content>
												<v-list-item-content class="align-end">{{ calcNumber(task.context.devices) }}</v-list-item-content>
											</v-list-item>
											<v-list-item>
												<v-list-item-content>Assigned to:</v-list-item-content>
												<v-list-item-content class="align-end">{{ task.assigned_to }}</v-list-item-content>
											</v-list-item>
											<v-list-item>
												<v-list-item-content>Performed by:</v-list-item-content>
												<v-list-item-content class="align-end">{{ task.performed_by }}</v-list-item-content>
											</v-list-item>
											<v-list-item>
												<v-list-item-content>Completed on:</v-list-item-content>
												<v-list-item-content class="align-end">{{ formateCreatedDate(task.completed_on) }}</v-list-item-content>
											</v-list-item>
											<v-list-item>
												<v-list-item-content>Task Type:</v-list-item-content>
												<v-list-item-content class="align-end">{{ task.task_type }}</v-list-item-content>
											</v-list-item>
										</v-list>
									</v-card>
								</v-col>
							</v-row>
						</template>
					</v-data-iterator>
				</td>
			</template>
		</v-data-table>
	</div>
</template>

<script>

	import { AmplifyEventBus } from "aws-amplify-vue";
	import { GetJobArchived } from "@/services/API.js";

	import TableRefresh from '@/components/general/TableRefresh.vue';

	import moment from "moment"

	import { Logger } from "aws-amplify";
	const logger = new Logger("JobsOld");

	export default {
		components: {
			TableRefresh
		},
		props: {
			latestjob: {
					type: Object,
					required: false,
					default: () => {}
			}
    },
		data: () => ({
			search: '',
			jobs: [],
			expanded: [],
			headers: [
				{ text: "Job", value: "name" },
				{ text: "Organisation", value: "org" },
				{ text: "Created On", value: "created_on" },
				{ text: "Completed On", value: "completed_on" },
				{ text: "Reporter", value: "created_by" },
				{ text: "Assignee", value: "assigned_to" }
			],
			loading: true
		}),

		watch: {
        latestjob(job) {
            this.jobs.push(job);
        }
    },

		async mounted() {
			this.getJobs();
		},

		destroyed() {
			AmplifyEventBus.$off("job-now");
		},

		methods: {
			formateCreatedDate(date) {
				return moment(date).format("YYYY-MM-DD HH:mm:ss")
			},
			async getJobs() {
				this.loading = true;
				let params = { 
                text_searches: [
										{
                        attribute: "archived",
                        value: "true"
                    }
                ]
            }

				const res = await GetJobArchived(params);
				if (res.Jobs) this.jobs = res.Jobs;
				this.loading = false;
				AmplifyEventBus.$on("job-now", this.handleJob);
				logger.info(this.jobs);
			},
			calcNumber(tags) {
				return tags.filter(tag => tag.vehicle_name).length;
			},

			handleJob(event) {
				switch (event.action) {
					case "remove":
						this.jobs.push(event.job);
						break;
					default:
						break;
				}
			},

			clickRow(item) {
				if (this.expanded[0] && this.expanded[0].id === item.id) {
					this.expanded = [];
				} else {
					this.expanded = [item];

					requestAnimationFrame(() => {
						this.$refs.slide.onResize();
					});
				}
			}
		}
	};
</script>

<style lang="scss">
    .search-bar {
        width: 20em;
        padding-left: 1em;
    }
</style>